export enum QueryCacheEnum {
  ACTIVITIES = 'Activities',
  AFTER = 'After',
  AGENTS_CONFIGURATIONS = 'AgentsConfigurations',
  ALICES = 'Alices',
  ANNOUNCEMENTS = 'Announcements',
  APP_VERSION = 'AppVersion',
  ATTACHMENTS = 'Attachments',
  AUTH = 'Auth',
  BEFORE = 'Before',
  BELONGS_TO = 'BelongsTo',
  BROADCASTS = 'Broadcasts',
  BROADCAST = 'Broadcast',
  BROADCAST_TARGETS = 'BroadcastTargets',
  CHANNEL = 'Channel',
  CHANNELS = 'Channels',
  COGNITO = 'Cognito',
  COGNITO_USERS = 'CognitoUsers',
  CONDITION_CHECK = 'ConditionCheck',
  CURRENT = 'Current',
  CURRENT_LOCATION = 'CurrentLocation',
  CURSORS = 'Cursors',
  DEVICES = 'Devices',
  DOCUMENT_REQUEST = 'DocumentRequest',
  DOWNLOADED_ATTACHMENTS = 'DownloadedAttachments',
  DRIVERS = 'Drivers',
  ELECTRONIC_SIGNATURE = 'ElectronicSignature',
  FIREBASE = 'Firebase',
  GIT_VERSION = 'GitVersion',
  GOOGLE_PLACE_DETAILS = 'GooglePlaceDetails',
  HOS = 'HOS',
  IDENTITIES = 'Identities',
  IS_ADMIN = 'IsAdmin',
  IS_ORG_ADMIN = 'IsOrgAdmin',
  LANGUAGES = 'Languages',
  MANAGED_BY = 'ManagedBy',
  MANAGED_MEMBERS = 'ManagedMembers',
  MANAGED_ORGS = 'ManagedOrgs',
  MANAGED_ORGS_BY_ALICE = 'ManagedOrgsByAlice',
  MAPPINGS = 'Mappings',
  MEMBERS = 'Members',
  MESSAGES = 'Messages',
  ORGANIZATION = 'Organization',
  ORGANIZATIONS = 'Organizations',
  RADAR = 'Radar',
  TENANCY = 'Tenancy',
  REPLY_CONTEXTS = 'ReplyContexts',
  REQUESTER = 'Requester',
  REQUEST_TYPE = 'RequestType',
  ROOT = 'Root',
  SAME_ROOT = 'SameRoot',
  SEARCH = 'Search',
  SECRETS = 'Secrets',
  SENDER = 'Sender',
  TENANTS = 'Tenants',
  TOKEN = 'Token',
  TRANSLATIONS = 'Translations',
  USAGE_RECORDS = 'UsageRecords',
  USER = 'User',
  VENDOR_GROUPS = 'VendorGroups',
  VENDOR_GROUPS_WITH_MEMBERS = 'VendorGroupsWithMembers',
  WATCHING = 'Watching',
  WATCHED_BY = 'WatchedBy',
  WHITELABEL = 'Whitelabel',
  WHO_AM_I = 'WhoAmI',
}
